import { render } from "./PlayersBox.vue?vue&type=template&id=2a1dc05a"
import script from "./PlayersBox.vue?vue&type=script&lang=js"
export * from "./PlayersBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__